import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "components/menu";
import config from "./config";

class PetProfile extends Component {
  render() {
    return <Menu {...config} {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.intl.locale,
    pet: state.reducers.pets.selectedPet,
    messages: state.intl.messages.containers.pets.petProfile,
    userPreferredUnit: state.reducers.auth.user.featurePreferences.weightUnit,
  };
};

export default connect(mapStateToProps)(PetProfile);
